<template>
  <div class="status_popover">
    <div class="p-3" v-if="popup_type == 'status_change' " :class="(view_type == 'mobile') ? 'popover_mobile_content' : 'popover_content'" >

        <h4><b>Mark as {{action}}?</b>
            <img v-on:click="cancelStatus" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">

        <p class="font-20" v-if="(this.$session.get('multi_book_id') == 0)">

            <span v-if="(action == 'Booked') || (action == 'Arrived')">Are you sure you want to change booking status to {{action}} ?</span>

            <span  v-else>Please note that you won't be able to change status again for this booking.</span>
        </p>

        <p class="font-20" v-else>

            <span v-if="(action == 'Booked') || (action == 'Arrived')">Please note that this will apply to all other services in this booking.</span>

            <span v-else>Please note that this status will apply to all other services in this booking. And you won't be able to change status again for this booking.</span>  

        </p>

        <!-- <p class="green">Note: if you want to make status changes to single service, you can use clipboard feature to reschedule first and to create new booking with the services you want, then make changes to the service.</p> -->
        
        <div class="row" v-if="view_type == 'mobile'">
            <div class="col-12">
                <hr>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded"  @click="cancelStatus">Cancel</button>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded btn_ash_shadow" @click="updateStatus(value)">Confirm</button>
            </div>
        </div>

        <div class="row" v-else>
            <div class="col text-right">
                <button type="button" class="btn btn-lg btn-ash btn-rounded mx-3"  @click="cancelStatus">Cancel</button>
                <button type="button" class="btn btn-lg btn-pink btn-rounded mx-3 btn_ash_shadow" @click="updateStatus(value)">Confirm</button>
            </div>
        </div>

    </div>

     <!-- START: Service remove in edit booking popup  -->
    <div class="p-3 popover_content" v-else-if="popup_type == 'service_remove'">

        <h4><b>Remove {{service_type}}?</b>
            <img v-on:click="closeServicePopUp" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">

        <p class="font-20">Are you sure to remove this service from booking, please note that this change is not reversible.</p>

        <!-- <p class="green font-14">Note: if you remove this {{service_type}}, it will be no longer associated with this booking and no history recorded further for this service.</p> -->
        
        <div class="row">
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded"  @click="closeServicePopUp"><b>Don't Remove</b></button>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded btn_ash_shadow" @click="removeService"><b>Remove</b></button>
            </div>
        </div>
    </div>
    <!-- END: Service remove in edit booking popup  -->

    <!-- START: Delete product -->
    <div class="p-3 popover_content" v-else-if="popup_type == 'delete_product'">

        <h4><b>Delete Product?</b>
            <img v-on:click="closeServicePopUp" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">

        <p class="font-20">Are you sure to delete this product, please note that this change is not reversible.</p>

        <div class="row pt-2">
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded"  @click="closeServicePopUp"><b>Cancel</b></button>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded btn_ash_shadow" @click="removeService"><b>Delete</b></button>
            </div>
        </div>
    </div>
    <!-- END: Delete product -->
    
    <!-- START: Discard Changes -->
    <div class="p-3 popover_content" v-else-if="popup_type == 'Discard_Changes'">

        <h4><b>Discard changes?</b>
            <img v-on:click="closeServicePopUp" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">

        <p class="font-20">Are you sure you want to discard all the changes you made to this product.</p>

        <div class="row pt-2">
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded"  @click="closeServicePopUp"><b>Cancel</b></button>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded btn_ash_shadow" @click="discard_changes"><b>Discard</b></button>
            </div>
        </div>
    </div>
    <!-- END: Discard Changes -->

     <!-- START: remove product -->
    <div class="p-3 popover_content" v-else-if="popup_type == 'product_remove'">

        <h4><b>Remove Product?</b>
            <img v-on:click="closeServicePopUp" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">

        <p class="font-20">Are you sure to remove this product from booking, please note that this change is not reversible.</p>

        <div class="row pt-2">
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded"  @click="closeServicePopUp"><b>Cancel</b></button>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded btn_ash_shadow" @click="remove_product"><b>Remove</b></button>
            </div>
        </div>
    </div>
    <!-- END: remove product -->

    <!-- START: Event dragged to clipboard is not allowed Alert  -->
    <div v-else-if="popup_type == 'non_draggable_event_to_clipboard'" class="p-3 popover_content">
        <h4>
            <b>Reschedule</b>
            <img @click="$emit('close')" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">
        <p class="ash font-20"><b>Note</b></p>
        <p class="font-20">Only bookings with status <b>Booked, Arrived</b> are allowed to reschedule.</p>

        <button type="button" class="btn btn-lg btn-ash btn-rounded pull-right"  @click="$emit('close')">
            <b>Close</b>
        </button>
    </div>
    <!-- END: Event dragged to clipboard is not allowed Alert  -->


    <!-- START: Discard Clipboard Popup  -->
    <div v-else-if="popup_type == 'discard_clipboard'" class="p-4 discard_popover_content">

        <h4>
            <b>Restore Bookings?</b>
            <img @click="$emit('close')" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">
        <p class="font-20 text-center"> Closing the clipboard will restore the bookings back to the original time slots.</p>

        <!-- <div class="col-md-12">
            <button type="button" class="btn btn-lg btn-block btn-blue btn-rounded btn_ash_shadow" @click="$emit('close')"><b>Continue Rescheduling</b></button>
        </div> -->
        <div class="col-md-12 pt-3">
            <button type="button" class="btn btn-lg btn-block btn-blue btn-rounded btn_ash_shadow" @click="clear_events_in_clipboard"><b>Close & Restore</b></button>
        </div>

    </div>
    <!-- END: Discard Clipboard Popup  -->


    
  </div>
</template>

<script>
export default {
    name: 'popover',
    data(){
        return {
        }
    },
    props: {
        action : String,
        value : Number,
        view_type : String,
        popup_type : String,
        service_type : String,
        serv_index: Number
    },
    methods:{

        async updateStatus(status){
            await this.$store.commit('service_status_update',[this.$session.get('book_id'),this.$session.get('multi_book_id')?this.$session.get('multi_book_id'):0,status,this.$store.state.user_id,this.Constants.BOOKED_THROUGH_ADMIN]);
            this.$emit('changePopStatus');
        },

        cancelStatus(){
            this.$emit('cancelPopStatus');
        },

        removeService(){
            this.$emit('removeService','Delete');
        },
        discard_changes(){
            this.$emit('removeService','Discard');
        },
        closeServicePopUp(){
            this.$emit('closePopUp');
        },

        clear_events_in_clipboard() { 
            this.$emit('clear_events_in_clipboard'); 
        },
        remove_product(){
            this.$emit('remove_product_from_booking')
        }

    }
}
</script>

<style scoped>
    .status_popover{
        position: fixed;
        z-index: 2000;
        top:0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0,0,0,0.4);
    }

    .popover_content{
        position: absolute;
        top: 30%;
        left: 35%;
        width: 30%;
        background: #ffffff;
        border-radius: 6px;
    }

    .popover_mobile_content{
        position: absolute;
        width: 100%;
        bottom: 0;
        background: #ffffff;
        border-radius: 6px 6px 0 0;
    }

    .discard_popover_content{
        position: absolute;
        top: 30%;
        left: 37%;
        width: 25%;
        background: #ffffff;
        border-radius: 6px;
    }
</style>